import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  DataSources,
  AmenitiesSourceLabel,
  SourceList,
} from './Amenities.styles'

export interface AmenitiesDataSourcesProps {
  sources?: string[]
  className?: string
}

/**
 * AmenitiesDataSources component displays the data sources used for amenities information.
 * If no sources are provided, it shows default sources (OpenStreetMap, Google Places, Swiss Federal Statistical Office).
 *
 * @param sources - Optional array of source names to display
 * @param className - Optional CSS class name
 */
export const AmenitiesDataSources: React.FC<AmenitiesDataSourcesProps> = ({
  sources,
  className,
}) => {
  const { t } = useTranslation('amenities')

  const defaultSources = [
    t('sources.openStreetMap'),
    t('sources.googlePlaces'),
    t('sources.swissFederalStatisticalOffice'),
  ]

  const displaySources = sources || defaultSources

  return (
    <DataSources className={className}>
      <AmenitiesSourceLabel>{t('sources.label')}</AmenitiesSourceLabel>
      <SourceList>{displaySources.join(' • ')}</SourceList>
    </DataSources>
  )
}

export default AmenitiesDataSources
